var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"container-web"}},[_c('AppContentHeader'),_c('AppContentHeaderLoketDigital'),_c('div',{staticClass:"content"},[_vm._t("default"),_c('AppContentFooter')],2),_c('AppTrackingCode')],1)}
var staticRenderFns = []

export { render, staticRenderFns }